export var Vec2 = function Vec2(_ref) {
  var _this = this;

  var x = _ref.x,
      y = _ref.y;

  this.toString = function () {
    return _this.x + " " + _this.y;
  };

  this.x = x;
  this.y = y;
};